import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { laneColors, REPLAY_LANES, type IDayMarkers } from './markers';
import type { ReplayMarkerView } from './useMarkerView';
import styles from './ReplayBar.module.css';

interface IMarkerViewFooterProps {
  markers: IDayMarkers;
  view: ReplayMarkerView;
  onToggle(): void;
}

/**
 * Under the track: each lane's count for the day, with a dot per kind it holds,
 * and the link that switches between badges and lanes. Memoized: the bar
 * re-renders on every playback tick, the footer only when the day or view changes.
 */
export const MarkerViewFooter = memo(function MarkerViewFooter({ markers, view, onToggle }: IMarkerViewFooterProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.footer}>
      {REPLAY_LANES.map((lane) => (
        <span key={lane} className={styles.legendItem}>
          {laneColors(lane).map((color) => (
            <span key={color} aria-hidden className={styles.legendDot} style={{ background: color }} />
          ))}
          {t(`monitor.replay.lanes.${lane}`)} {markers.byLane[lane].length}
        </span>
      ))}
      <span className={styles.spacer} />
      <button type="button" className={styles.viewLink} onClick={onToggle}>
        {t(view === 'badges' ? 'monitor.replay.showLanes' : 'monitor.replay.showBadges')}
      </button>
    </div>
  );
});
